const getters = {
  unitLabel: state => {
    let index = state.unitDataOptions.findIndex(item => item.value === state.graph.unit)
    return state.unitDataOptions[index].simplify
  },
  // 例えば、”Ratio”という欄を追加して、”3”と入力するとマスターデータのratio3までのデータを参照する、”4”と入力するとratio4までのデータを参照する、など。
  selectedLensData_lcd_distInfo: state => {
    var ratioList = []
    if (state.selectedModelData) {
      if (state.selectedModelData.ratio !== '-') {
        let num = parseInt(state.selectedModelData.ratio)
        if (!isNaN(num)) {
          ratioList = state.selectedLensData.lcd.distInfo.slice(0, num)
        }
      } else {
        ratioList = state.selectedLensData.lcd.distInfo
      }
      return ratioList.filter(item => { return item.ratio !== '' && item.ratio !== '-' })
    } else {
      return []
    }
  }
}
export default getters
